export enum AppRoutes {
	HOME = '/home',
	COMPANY_DATA = 'home/company-data',
	VERIFY = '/home/verify-data',
	ERROR = '/error',
}

export enum ApiEndpoints {
	INITIAL_PARAMETERS = '/simulador-publico',
	VALIDATE = '/cliente/valida',
	GENERATE_SEND_OTP = '/codigos-otp/generacion-envio',
	OTP_VALIDATION = '/codigos-otp/validacion',
}
